import { ClassTreeNode } from '../models/frontend_entities/ClassTreeNode';
import { CompoClass } from '../models/component_class/CompoClass';
import { MapUtils } from './MapUtils';
import { ClassTreeUtils } from './ClassTreeUtils';
import { ClassUtils } from './ClassUtils';

export function cloneAndMarkCheckinTemplateNode(
  node: ClassTreeNode,
  disabledIds: Set<string>
): ClassTreeNode {
  const isLeaf = Boolean(node.compoClass?.canContainComponent || !node.children || node.children.length === 0);
  const clonedChildren = (node.children || []).map(child => cloneAndMarkCheckinTemplateNode(child, disabledIds));

  let isNodeDisabled: boolean;
  if (isLeaf) {
    isNodeDisabled = Boolean(disabledIds && node.compoClass?.id && disabledIds.has(node.compoClass.id));
  } else {
    isNodeDisabled = clonedChildren.length > 0 && clonedChildren.every(child => child.disabled);
  }

  return {
    ...node,
    disabled: isNodeDisabled,
    children: clonedChildren
  };
}

export function buildCheckinTemplateClassTree(
  compoClasses: CompoClass[],
  disabledIds: Set<string> = new Set<string>()
): ClassTreeNode[] {
  if (!compoClasses || compoClasses.length === 0) {
    return [];
  }
  const classMap = MapUtils.arrayToMap(compoClasses, 'id');
  const classTreeNodes = ClassTreeUtils.buildTreeNodes(classMap, false, false, []);
  return (classTreeNodes[0]?.children || []).map(node => cloneAndMarkCheckinTemplateNode(node, disabledIds));
}

export function getCheckinTemplateLeafContainerIds(node: ClassTreeNode): string[] {
  const leafIds: string[] = [];
  const traverse = (n: ClassTreeNode) => {
    if (!n) return;
    if (n.compoClass?.canContainComponent || !n.children || n.children.length === 0) {
      if (n.compoClass?.id && n.compoClass.id !== ClassUtils.INSTANCE_ROOT_CLASS_ID) {
        leafIds.push(n.compoClass.id);
      }
    } else {
      n.children?.forEach(child => traverse(child));
    }
  };
  traverse(node);
  return leafIds;
}

export function getCheckinTemplateAllLeafClassIds(compoClasses: CompoClass[]): string[] {
  return (compoClasses || [])
    .filter(c => c.canContainComponent && c.id !== ClassUtils.INSTANCE_ROOT_CLASS_ID)
    .map(c => c.id);
}
